import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ArrangeLayersIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M20.772 15a1 1 0 01.992 1.008 2 2 0 01-.964 1.696l-.142.078-6.87 3.435a4 4 0 01-3.363.099l-.214-.099-6.87-3.435a2 2 0 01-1.105-1.766 1 1 0 011.992-.14l.008.117 6.87 3.435a2 2 0 001.617.076l.171-.076 6.87-3.436A1 1 0 0120.772 15zm0-4a1 1 0 01.992 1.008 2 2 0 01-.964 1.696l-.142.078-6.87 3.435a4 4 0 01-3.363.099l-.214-.099-6.87-3.435a2 2 0 01-1.105-1.766 1 1 0 011.992-.14l.008.117 6.87 3.435a2 2 0 001.617.076l.171-.076 6.87-3.436A1 1 0 0120.772 11zm-10.56-8.224a4 4 0 013.577 0l6.87 3.435a2 2 0 010 3.578l-6.87 3.435a4 4 0 01-3.578 0l-6.87-3.435a2 2 0 010-3.578zm2.682 1.79a2 2 0 00-1.788 0L4.236 8l6.87 3.435a2 2 0 001.788 0L19.764 8z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ArrangeLayersIcon.isCarinaIcon = true;
export default ArrangeLayersIcon;
